import {RecordForm} from '../forms/RecordForm';
import {useInvoice} from '../hooks/useInvoice';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {Invoice} from "../types.ts";
import {useParams} from "react-router-dom";

export const AddPage = () => {
    const { createRecord } = useInvoice();
    const { id: customerId } = useParams();

    return (
        <FormPageLayout
            title='Add Invoice'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={{ customerId } as Invoice} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};